/* third libraries */

// repair youtube videos

function youtubeVideosRepair(){

	var allVideos = $("iframe[src*=\"youtube.com\"]");


	allVideos.each(function(){

		$(this).wrap('<div class="video-wrapper"></div>')
		$(this).addClass('visible');

	});

}


// config variables
var breakpoint = 720;

// for hamburguer
function hamburgerBehavior(burgerSelector, menuSelector){

	// toogle button
	$(burgerSelector).click(function(){
		$(this).toggleClass('is-active');
		$(menuSelector).toggleClass('expanded');
		$(menuSelector).slideToggle();
	});
}

// comprueva la medida del navegador
function repairBurgerBehaviors(breakpoint, menuSelector, burgerSelector){

	var breakpointValue = window.matchMedia("(max-width: " + breakpoint + "px)").matches;

	if(breakpointValue){
		$(menuSelector).css('display', 'none');
	} else {
		$(menuSelector).css('display', 'block');
		$(burgerSelector).removeClass('is-active');
	}
}


// repair current menu
function addCurrentToLinks(){
	var menuLinks = $('.main-nav a');
	var currentUrl = window.location.href.toString().split('/').pop();

	menuLinks.each( function(){

		var currentLinkUrl = $(this).attr('href');
		currentLinkUrl = currentLinkUrl.replace(/\/$/, '');
		currentLinkUrl = currentLinkUrl.split('/').pop();


		if( currentUrl === currentLinkUrl ){
			$(this).closest('li').addClass('brcm-active-node');
		}

	});
}

// DOCUMEN READY
$(function() {

	///
	hamburgerBehavior('#burger', '.main-nav');

	// repair menu on resize
	repairBurgerBehaviors(breakpoint, '.main-nav', '#burger');

	$(window).resize(function(){
		repairBurgerBehaviors(breakpoint, '.main-nav', '#burger');
	});

	//
	youtubeVideosRepair();

	//
	addCurrentToLinks();

});
